import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layouts
import MainLayout from "./layouts/MainLayout";
import BareLayout from "./layouts/BareLayout";

// Pages
import Landingpage from "./pages/Landingpage";
import Marketplace from "./pages/Marketplace";
import Home from "./pages/Home";
import AppViewPage from "./pages/AppViewPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminAppPage from "./pages/AdminAppPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* 🔹 NO Navbar */}
        <Route element={<BareLayout />}>
          <Route path="/" element={<Landingpage />} />
          {/* <Route path="/:workspaceId" element={<Home />} /> */}
          <Route path="/:workspaceId/:appId" element={<AppViewPage />} />
        </Route>

        {/* 🔹 WITH Navbar */}
        <Route element={<MainLayout />}>
          {/* <Route path="/marketplace" element={<Marketplace />} /> */}
          {/* <Route path="/admin/:workspaceId" element={<AdminDashboard />} /> */}
          <Route path="/admin/:workspaceId/:appId" element={<AdminAppPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
